/**
 * Add a new task to the existing queue
 */
function queueTask(queue, task) {
    return {
        ...queue,
        tasks: [...queue.tasks, task],
    };
}

export { queueTask };
